import styled from "styled-components";
import { buildText } from "../../_atom/Text";
import buildColor from "../../_static/ColorPalette";
import { fontBold, fontMedium } from "../../_static/Typography";

export const ImageRain = styled.img`
  position: absolute;
  height: 150px;

  @media only screen and (min-width: 486px) {
    height: 360px;
  }
`;

export const LogoWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;

export const OuterContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: transparent;
  z-index: 0;
  align-items: center;

  @media only screen and (max-width: 767px) {
    min-height: 100vh;
  }
`;

export const Background = styled.div`
  left: 0;
  top: 0;
  position: fixed;
  display: flex;
  z-index: -1;
  height: 100%;
  width: 100%;
  justify-content: center;
  background: ${({ hasPromo }) =>
    hasPromo
      ? "linear-gradient(180deg, #194546 0%, #112b44 100%)"
      : "linear-gradient(180deg, #112b44 0%, #1a4066 100%)"};
  @media (min-width: 486px) {
    background: ${({ hasPromo }) =>
      hasPromo
        ? "linear-gradient(180deg, #112b44 0%, #194546 30%, #112b44 100%)"
        : "linear-gradient(180deg, #112b44 0%, #1a4066 100%)"};
  }
`;

export const BodyContainer = styled.div`
  padding: 0 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 76px;
  @media (min-width: 486px) {
    margin-top: 150px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${fontMedium};
  width: 100%;
  margin-top: ${({ innerList }) => (innerList ? "20px" : "40px")};

  a:last-of-type {
    margin-top: 12px;
  }
`;

export const InnerContainer = styled.div`
  background-color: ${buildColor("white", "100")};
  display: flex;
  padding: 12px;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  align-self: center;
  border: 2px solid ${buildColor("blue", "100")};
  margin-top: 40px;
  border-radius: 4px;
`;

export const InnerTitle = styled.h2`
  font-family: ${fontBold};
  font-weight: 500;
  margin-bottom: 8px;
  line-height: 18px;
  font-size: 14px;
  color: ${buildColor("grey", "900")};
  @media (min-width: 486px) {
    line-height: 26px;
    font-size: 20px;
  }
`;

export const InnerList = styled.ul`
  padding-left: 26px;
  padding-bottom: 20px;
`;
export const ListItem = styled(
  buildText({
    tag: "li",
    fontWeight: 400,
    color: buildColor("grey", "800")
  })
)`
  line-height: 18px;
  list-style: disc;
  padding: 2px 0;
  font-size: 14px;
  @media (min-width: 486px) {
    line-height: 24px;
    font-size: 18px;
  }
`;

export const ListItemComplete = styled(ListItem)`
  color: ${buildColor("green", "500")};
  display: flex;
  align-items: center;
`;

export const IconContainer = styled.div`
  position: relative;
  left: 0;
  background: red;
  align-items: center;
  display: flex;
  > svg {
    position: absolute;
    right: 7px;
  }
`;
